"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _QRBackgroundColor = require("./QRBackgroundColor");
Object.keys(_QRBackgroundColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QRBackgroundColor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _QRBackgroundColor[key];
    }
  });
});
var _QRTextPosition = require("./QRTextPosition");
Object.keys(_QRTextPosition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QRTextPosition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _QRTextPosition[key];
    }
  });
});
var _TranslationKey = require("./TranslationKey");
Object.keys(_TranslationKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationKey[key];
    }
  });
});
